import { render, staticRenderFns } from "./HeaderLogged.vue?vue&type=template&id=4f06b774&scoped=true"
import script from "./HeaderLogged.vue?vue&type=script&lang=js"
export * from "./HeaderLogged.vue?vue&type=script&lang=js"
import style0 from "./HeaderLogged.vue?vue&type=style&index=0&id=4f06b774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f06b774",
  null
  
)

export default component.exports